import { FragmentOf, readFragment } from "gql.tada";

import { readImageConnectionFragment } from "./imageConnectionFragment";
import RestaurantFragment from "./restaurant";
import { hasId } from "../../utils/store";

const parseCoordinate = (
  value: number | string | null | undefined,
): number | null => {
  if (value == null) {
    return null;
  }

  const coordinate = Number(value);
  return Number.isFinite(coordinate) ? coordinate : null;
};

/**
 * Normalizes store-backed restaurant details into the shape expected by
 * restaurant detail UI and analytics (aligned with the app `readRestaurantFragment`).
 */
export const readRestaurantFragment = (
  fragment: FragmentOf<typeof RestaurantFragment> | null | undefined,
) => {
  if (!fragment) return null;

  const restaurant = readFragment(RestaurantFragment, fragment);

  if (!hasId(restaurant)) {
    return null;
  }

  const cleanedRestaurant = {
    ...restaurant,
    lat: parseCoordinate(restaurant.lat),
    lng: parseCoordinate(restaurant.lng),
    images: readImageConnectionFragment(restaurant.images),
  };

  return cleanedRestaurant;
};
